/* import __COLOCATED_TEMPLATE__ from './user-summary-user.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./user-summary-user.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "li"
}));